import type { BrandStyle } from '@/types/user-settings'

export const DefaultBrandStyle: Partial<BrandStyle> = getDefaultBrandStyles()

export function hexToRgb(hex: string): {
  red: number
  green: number
  blue: number
} {
  const cleanHex = hex.replace('#', '')
  const hexValue = Number.parseInt(cleanHex, 16)
  const red = (hexValue >> 16) & 255
  const green = (hexValue >> 8) & 255
  const blue = hexValue & 255
  return { red, green, blue }
}

export function setHexAlpha(color?: string, alpha?: number): string {
  if (!color || !alpha) return ''
  const rgb = hexToRgb(color)
  if (!rgb) return ''
  return `rgba(${rgb.red},${rgb.green},${rgb.blue},${alpha})`
}

const cssSizeWords = ['auto', 'inherit', 'initial', 'unset', 'rem', 'em', 'px', 'var', '%']
export function cssNum(value: number | string | undefined): string {
  if (value === undefined) return ''
  const strify = `${value ?? 0}`.trim().toLowerCase()
  if (cssSizeWords.some((word) => strify.includes(word))) return strify
  return `${strify}px`
}

export function getDefaultBrandStyles(): Partial<BrandStyle> {
  return {
    brandColor: '#6262F5',
    dangerColor: '#D93232',
    successColor: '#0A803A',
    textPrimary: '#080808',
    textSecondary: '#626875',
    borderPrimary: '#E2E6ED',
    buttonPrimary: {
      bg: '#6262F5',
      color: '#FFFFFF',
      borderColor: '#6262F5',
      borderRadius: {
        bottomLeft: 100,
        bottomRight: 100,
        topLeft: 100,
        topRight: 100,
      },
    },
    buttonSecondary: {
      bg: '#FFFFFF',
      color: '#080808',
      borderColor: '#E2E6ED',
      borderRadius: {
        bottomLeft: 100,
        bottomRight: 100,
        topLeft: 100,
        topRight: 100,
      },
    },
    input: {
      bg: '#FFFFFF',
      color: '#080808',
      borderColor: '#E2E6ED',
      borderRadius: {
        bottomLeft: 8,
        bottomRight: 8,
        topLeft: 8,
        topRight: 8,
      },
    },
  }
}
